import {ADMIN_MENU_LOADING, ADMIN_MENU_SET} from "./adminMenuActions";

const defaultState = {data: null, loading: false};

const adminMenuReducer = (state = {inGame: defaultState, general: defaultState}, action) => {
    switch (action.type) {
        case ADMIN_MENU_LOADING:
        case ADMIN_MENU_SET:
            return {...state, [action.meta.source]: singleMenuReducer(state[action.meta.source], action)};
        default:
            return state;
    }
};

const singleMenuReducer = (state, action) => {
    switch (action.type) {
        case ADMIN_MENU_LOADING:
            return {data: [], loading: true};
        case ADMIN_MENU_SET:
            return {data: action.payload, loading: false};
        default:
            return state;
    }
};

export default adminMenuReducer;